import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { WhoWeWorkWith } from "@/components/site/WhoWeWorkWith";
import { Services } from "@/components/site/Services";
import { HowItWorks } from "@/components/site/HowItWorks";
import { WhyCrownpath } from "@/components/site/WhyCrownpath";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white">
      <Navbar />
      <Hero />
      <WhoWeWorkWith />
      <Services />
      <HowItWorks />
      <WhyCrownpath />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}
